import React from "react";
import styles from "./SidePanelContainer.module.css";

export default function SidePanelContainer({ children, className = "" }) {
	return <div className={`${styles.container} ${className}`}>{children}</div>;
}
